import { memo } from 'react';
import InboxTabNavigator from '../components/InboxTabNavigator';

function InboxModal() {
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   return () => {
  //     dispatch(acknowledgeInbox());
  //   };
  // }, [dispatch]);

  return <InboxTabNavigator />;
}

export default memo(InboxModal);
